import PropTypes from 'prop-types';
import { useRef } from 'react';

import Anchor from 'components/Anchor';
import Image from 'components/Image';
import Sidebar from 'components/Sidebar';
import FeaturedOffersList from 'components/Sidebar/FeaturedOffersList';
import SidebarGoogleAd from 'components/Sidebar/GoogleAd';
import OffersSidebarBox from 'components/Sidebar/OffersSidebarBox';
import SidebarRelevantSubcategories from 'components/Sidebar/RelevantSubcategories';

import { sendEvent } from 'lib/gtag';

import APP from 'constants/app';
import WHATSAPP_GROUP from 'constants/whatsappGroupCampaign';

const ArticleSidebar = ({ featuredOffers = [] }) => {
  const featuredOffersListRef = useRef(null);
  const offersSidebarBoxRef = useRef(null);
  const midGoogleAdRef = useRef(null);
  const relevantSubcategoriesRef = useRef(null);

  const onWhatsAppCampaignBannerClick = (gaEventCategory) => {
    sendEvent({
      action: 'whatsapp_group_banner_click',
      category: gaEventCategory,
    });
  };

  return (
    <Sidebar
      className="col-span-4 gap-y-4 xl:col-span-3"
      refsToBeIgnoredBeforeFixing={[
        offersSidebarBoxRef,
        midGoogleAdRef,
        featuredOffersListRef,
        relevantSubcategoriesRef,
      ]}
    >
      <Anchor
        className="w-full"
        href={WHATSAPP_GROUP.DEFAULT_GROUP_URL}
        rel="noopener noreferrer"
        target="_blank"
        onClick={() => onWhatsAppCampaignBannerClick('article_top')}
      >
        <Image
          alt="Ilustração de grupos do Promobit no WhatsApp"
          className="w-full rounded-2"
          height={250}
          src={`${APP.LOCAL_IMAGE_PATH}/features/whatsapp/whatsapp_blog_sidebar-v3.png`}
          width={300}
        />
      </Anchor>
      <OffersSidebarBox ref={offersSidebarBoxRef} />
      <SidebarGoogleAd
        ref={midGoogleAdRef}
        adId="blog_article_page_sidebar_2_300x250"
        adPath="/promobit.com.br_blog_article_page/sidebar_2_300x250"
      />
      <FeaturedOffersList
        ref={featuredOffersListRef}
        featuredOffers={featuredOffers}
      />
      <SidebarRelevantSubcategories ref={relevantSubcategoriesRef} />
      <Anchor
        className="w-full"
        href={WHATSAPP_GROUP.DEFAULT_GROUP_URL}
        rel="noopener noreferrer"
        target="_blank"
        onClick={() => onWhatsAppCampaignBannerClick('article_scroll')}
      >
        <Image
          alt="Ilustração de grupos do Promobit no WhatsApp"
          className="w-full rounded-2"
          height={250}
          src={`${APP.LOCAL_IMAGE_PATH}/features/whatsapp/whatsapp_blog_sidebar-v3.png`}
          width={300}
        />
      </Anchor>
    </Sidebar>
  );
};

ArticleSidebar.propTypes = {
  featuredOffers: PropTypes.arrayOf(
    PropTypes.shape({
      offerId: PropTypes.number.isRequired,
      offerTitle: PropTypes.string.isRequired,
      offerPrice: PropTypes.number.isRequired,
      offerOldPrice: PropTypes.number,
      offerPriceType: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string.isRequired,
      offerSlug: PropTypes.string.isRequired,
    })
  ),
};

export default ArticleSidebar;
